/**
 * A component to display the type and message of a flag on a program.
 * Used on the Progams Flag Queue page discussion/mod/flaggedfeedback#typeKey=PROGRAM
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import * as sharedStyles from "../shared-styles.ts";

import flagIcon from "@phosphor-icons/core/bold/flag-bold.svg";

type Props = {
    flagType: string;
    message?: string;
};

export default function ProgramFlag({
    flagType,
    message,
}: Props): React.ReactElement {
    return (
        <View style={styles.flag}>
            <PhosphorIcon size="small" icon={flagIcon} />
            <View style={styles.flagType}>{flagType}</View>
            {message && <View style={styles.flagMessage}>{message}</View>}
        </View>
    );
}

const styles = StyleSheet.create({
    flag: {
        flexDirection: "row",
        gap: spacing.xSmall_8,
        margin: `${spacing.xSmall_8}px 0`,
        alignItems: "center",
    },
    flagType: {
        flexShrink: 0,
    },
    flagMessage: {
        borderColor: sharedStyles.borderColor,
        borderLeftWidth: 2,
        padding: `0 0 0 ${spacing.xSmall_8}px`,
    },
});
